import ViewWinnerTable from './viewWinnerTable.container'

export default ViewWinnerTable